import { Toast } from '@leverege/ui-elements';
function showResponseToasts(configurationsWithReponse) {
  Object.entries(configurationsWithReponse).forEach(([camelCaseConfigType, {
    validLocations,
    omittedLocations,
    response
  }]) => {
    const configType = camelCaseToTitleCase(camelCaseConfigType);
    const {
      errorsWithLocationNames,
      successLocations
    } = getErrorAndSuccessLocations(validLocations, response?.errors);
    displayErrorToasts(errorsWithLocationNames, configType);
    displaySuccessToast(successLocations, omittedLocations, configType);
  });
}
function camelCaseToTitleCase(text) {
  const aux = text.replace(/([A-Z])/g, ' $1');
  return aux.charAt(0).toUpperCase() + aux.slice(1);
}
function getErrorAndSuccessLocations(locations, errors = []) {
  const errorsWithLocationNames = errors.map(error => {
    const location = locations.find(location => location.id === error.locationId);
    return {
      ...error,
      locationName: location.name
    };
  });
  const errorLocationsIds = errors.map(error => error.locationId);
  const successLocations = locations.filter(location => !errorLocationsIds.includes(location.id));
  return {
    errorsWithLocationNames,
    successLocations
  };
}
function displayErrorToasts(errorsWithLocationNames, configType) {
  errorsWithLocationNames.forEach(error => {
    Toast.error([`${error.locationName}: Failed to update ${configType} configuration.`, error.message]);
  });
}
function displaySuccessToast(successLocations, omittedLocations, configType) {
  const isNoRequestSentToast = omittedLocations.length > 0 && successLocations.length === 0;
  const isRequestSentWithOmittedLocationsToast = omittedLocations.length > 0 && successLocations.length > 0;
  const isRequestSentForAllLocationsToast = omittedLocations.length === 0 && successLocations.length > 0;
  switch (true) {
    case isNoRequestSentToast:
      return displayNoRequestSentToast(omittedLocations, configType);
    case isRequestSentWithOmittedLocationsToast:
      return displayRequestSentWithOmittedLocationsToast(successLocations, omittedLocations, configType);
    case isRequestSentForAllLocationsToast:
    default:
      return displayRequestSentForAllLocationsToast(successLocations, configType);
  }
}
function displayNoRequestSentToast(omittedLocations, configType) {
  if (omittedLocations.length > 1) {
    Toast.success([`${omittedLocations.length} locations`, `All selected location device groups already set to desired ${configType} configuration.`]);
  } else if (omittedLocations.length === 1) {
    Toast.success([omittedLocations[0].name, `Device group already set to desired ${configType} configuration.`]);
  }
}
function displayRequestSentWithOmittedLocationsToast(successLocations, omittedLocations, configType) {
  const numberOfLocations = omittedLocations.length + successLocations.length;
  const numberOfOmittedLocations = omittedLocations.length;
  const omittedLocationPlural = numberOfOmittedLocations > 1 ? 's' : '';
  Toast.success([`${numberOfLocations} locations`, `${configType} configuration updated successfully. ${numberOfOmittedLocations} location${omittedLocationPlural} 
    already set to desired configuration.`]);
}
function displayRequestSentForAllLocationsToast(successLocations, configType) {
  if (successLocations.length > 1) {
    Toast.success([`${successLocations.length} locations`, `${configType} configuration updated successfully.`]);
  } else if (successLocations.length === 1) {
    Toast.success([successLocations[0].name, `${configType} configuration updated successfully.`]);
  }
}
export default showResponseToasts;